export default __webpack_public_path__ + "static/media/banner.0485ad87.jpeg";